import { Theme, styled } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export const ContentCont = styled('div')<Theme, { jobs: number }>(({ theme, jobs }) => ({
  overflowY: 'auto',
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  gap: 20,
  paddingRight: 10,
  height: '100%',
  width: jobs ? '100%' : 'calc(100vw - 135px)',
  [theme.breakpoints.down('xs')]: {
    width: 'calc(100vw - 20px)',
  },
}));
